const config = require('../../config');

const store = config.ENVIRONMENT === 'production' ?
  require('./configureStore.prod.js') :
  require('./configureStore.dev.js');

module.exports = store;



// WEBPACK FOOTER //
// ./src/_app/store/store.js